import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logoBlanc from "./assets/vgd-logo-blanc.png";

import { ReactComponent as NewsletterIcon } from "./assets/newsletter.svg";
import { ReactComponent as PhoneCallIcon } from "./assets/phone-call.svg";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <div className="navbar">
        <div className="topNavbar">
          <a className="mail" href="mailto:contact@vgd-led.com"> 
            <NewsletterIcon className="icon" /> 
            <p>contact@vgd-led.com</p>
          </a>
          <a className="tel" href="tel:+33484980035"> 
            <PhoneCallIcon className="icon" /> 
            <p>+33 (0)4 84 98 00 35</p>
          </a>
        </div>
        <div className="bottomNavbar">
          <a href="https://vgd-led.com">← Retourner sur le site</a>
          <img src={logoBlanc} alt="Logo VGD"/>
        </div>
      </div>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
